export const profileArray = [
  {enum: '120p', width: 160, height: 120},
  {enum: '180p', width: 320, height: 180},
  {enum: '240P', width: 320, height: 240},
  {enum: '360p', width: 640, height: 360},
  {enum: '480p', width: 640, height: 480},
  {enum: '720p', width: 1280, height: 720},
  {enum: '1080p', width: 1920, height: 1080}
]

export const APP_ID = 'c0f3232443444ca3a439db68ce8e6c74' // input your app id here